module.exports = __webpack_public_path__ + "static/media/hcon-full-icon-4.f29915d5.svg";